import {
  assetsUrlsInterface,
  responseInterface,
} from "@/types";
import {
  httpClient,
  HttpClientGetParameters,
  HttpClientPutParameters,
  HttpClientDeleteParameters,
  HttpClientPostParameters,
} from "@/apiClient/models/http/httpClient.models";

export interface AssetsApiClientInterface {
  fetch: (lang: string) => Promise<responseInterface>;
  fetchAlbums: (lang: string) => Promise<responseInterface>;
  fetchTags: (lang: string) => Promise<responseInterface>;
  fetchPinnedAssets: (lang: string, userId: number) => any;
  pin: (lang: string, userId: number, assetId: string) => any;
  unpin: (lang: string, userId: number, assetId: string) => any;
  sortPinnedAssets: (lang: string, userId: number, ids: string[]) => any;
}

export class AssetsApi implements AssetsApiClientInterface {
  private readonly urls!: assetsUrlsInterface;

  constructor(urls: assetsUrlsInterface) {
    this.urls = urls;
  }

  fetch(lang: string): Promise<responseInterface> {
    const url = this.urls.fetch.replace("{%lang%}", lang as string);
    const getParameters: HttpClientGetParameters = { url, requiresToken: false };

    return httpClient.get<responseInterface>(getParameters);
  }

  fetchAlbums(lang: string): Promise<responseInterface> {
    const url = this.urls.fetchAlbums.replace("{%lang%}", lang as string);
    const getParameters: HttpClientGetParameters = { url, requiresToken: true };

    return httpClient.get<responseInterface>(getParameters);
  }

  fetchTags(lang: string): Promise<responseInterface> {
    const url = this.urls.fetchTags.replace("{%lang%}", lang as string);
    const getParameters: HttpClientGetParameters = { url, requiresToken: true };

    return httpClient.get<responseInterface>(getParameters);
  }

  fetchPinnedAssets(lang: string, userId: any): any {
    const url = this.urls.fetchPinnedAssets
      .replace("{%lang%}", lang)
      .replace(":userId", userId);

    const getParameters: HttpClientGetParameters = {
      url, requiresToken: true
    };

    return httpClient.get<responseInterface>(getParameters);
  }

  pin(lang: string, userId: any, assetId: string): any {
    const url = this.urls.markAssetAsPinned
      .replace("{%lang%}", lang)
      .replace(":userId", userId)
      .replace(":assetId", assetId);

    const PostParameters: HttpClientPutParameters = {
      url,
      payload: null,
      requiresToken: true,
    };

    return httpClient.put<responseInterface>(PostParameters);
  }

  unpin(lang: string, userId: any, assetId: string): any {
    const url = this.urls.unmarkAssetAsPinned
      .replace("{%lang%}", lang)
      .replace(":userId", userId)
      .replace(":assetId", assetId);
    const DeleteParameters: HttpClientDeleteParameters = { url, requiresToken: true };

    return httpClient.delete<responseInterface>(DeleteParameters);
  }

  sortPinnedAssets(lang: string, userId: any, ids: string[]): any {
    const url = this.urls.sortPinnedAssets
      .replace("{%lang%}", lang)
      .replace(":userId", userId);

    const PostParameters: HttpClientPostParameters = {
      url,
      payload: { ids },
      requiresToken: true,
    };

    return httpClient.post<responseInterface>(PostParameters);
  }
}
